import envs from '@/infrastructure/config/envs';

export class KalturaGateway {
  getRandomVideoThumbnailUrl(videoKalturaId: string): string | null {
    const videoMinuteFrameInSeconds = 60;
    return `${envs.kaltura_cdn}/thumbnail/entry_id/${videoKalturaId}/width/56/height/42/vid_sec/${videoMinuteFrameInSeconds}`;
  }
}
